export const DOWN_PAYMENT_AMOUNT_LISTS = [
  {
    label: "10,000",
    value: "10000",
  },
  {
    label: "40,000",
    value: "40000",
  },
  {
    label: "55,000",
    value: "55000",
  },
  {
    label: "60,000",
    value: "60000",
  },
  {
    label: "75000",
    value: "75000",
  },
  {
    label: "85,000",
    value: "85000",
  },
  {
    label: "95,000",
    value: "95000",
  },
  {
    label: "100,000",
    value: "100000",
  },
];
